/*
 * AdminSettings Messages
 *
 * This contains all the text for the AdminSettings component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  name: {
    id: 'app.common.name',
    defaultMessage: 'Name',
  },
  email: {
    id: 'app.components.EditProfile.email',
    defaultMessage: 'Email address',
  },
  dataProtectionOfficer: {
    id: 'app.components.AdminSettings.dataProtectionOfficer',
    defaultMessage: 'Data Protection Officer (DPO)',
  },
  dataProtectionOfficerIntro: {
    id: 'app.components.AdminSettings.dataProtectionOfficerIntro',
    defaultMessage: 'Because of the GDPR, it is important that we know who the DPO of your school is.',
  },
  setDataProtectionOfficer: {
    id: 'app.components.AdminSettings.setDataProtectionOfficer',
    defaultMessage: 'Set DPO',
  },
});
